import React, {useEffect, useState } from "react";

import "mapbox-gl/dist/mapbox-gl.css";
import "../../styles/MapComponent.css";
import {
  getRandomColor,
  getValidCoordinates,
} from "../../helpers/Utils";
import MarkerDetailComponent from "./MarkerDetailComponent";
import { MapContainer, TileLayer, CircleMarker, Popup, useMap } from "react-leaflet";
import "leaflet/dist/leaflet.css";



const ChangeCenter = ({ center }: { center: [number, number] }) => {
  const map = useMap();

  useEffect(() => {
    if (center) {
      map.setView(center, 5); // Keep current zoom
    }
  }, [center, map]);

  return null;
};


const MapComponent: React.FC<{ newsData, selectedNews? }> = ({
  newsData,
  selectedNews
}) => {
  const [mapData, setMapData] = useState(null);
  const [position, setPosition] = useState<[number, number]>([50, 15]);

  
  const handleCenterValue = () => {
    if(selectedNews && selectedNews.longitude && selectedNews.latitude) {
      setPosition([selectedNews.latitude, selectedNews.longitude])
    } else {
      const validData = getValidCoordinates(newsData);
      if (!validData || validData?.length === 0) {
        setPosition([50, 15]);
      } // lagore
      else {
        setPosition([validData[0].latitude, validData[0].longitude]);
      }
    }
  }
  
  const loadMap = () => {
    handleCenterValue();
    const markerData = [];
    newsData?.forEach((news) => {
      // Add a marker to the map
      if (news.longitude && news.latitude) {
        const findDuplicateCoordinates = markerData.find(
          (x) =>
            x.coordinates[0] === news.longitude &&
            x.coordinates[1] === news.latitude
        );
        if (findDuplicateCoordinates) {
          var index = markerData.indexOf(findDuplicateCoordinates);
          const tmpNewsData = findDuplicateCoordinates.newsData;
          tmpNewsData.push(news);
          markerData[index] = {
            coordinates: [news.longitude, news.latitude],
            newsData: tmpNewsData,
          };
        } else {
          const tmpNewsData = [];
          tmpNewsData.push(news);
          markerData.push({
            coordinates: [news.longitude, news.latitude],
            newsData: tmpNewsData,
          });
        }
      }
    });
    setMapData(markerData);
  };
  

  useEffect(() => {
    if (newsData && newsData.length > 0) {
      loadMap();
    } 
  }, [newsData, selectedNews]);


  return (
    <MapContainer
      center={position}
      zoom={3}
      style={{ height: "100vh", width: "100%" }}
    >
      <TileLayer
         url="https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png"
  attribution='&copy; <a href="https://carto.com/">CartoDB</a> contributors'
      />
      <ChangeCenter center={position} />
      {mapData?.map((loc, index) => (
        <CircleMarker
        key={index}
        center={[loc.coordinates[1], loc.coordinates[0]]}
        radius={10}
        color={getRandomColor()}
        fillColor={getRandomColor()}
        fillOpacity={0.6}
      >
          
          <Popup>
          <div style={{ width: '301px', maxHeight: '500px', overflowY: 'auto' }}>
            <MarkerDetailComponent newsData={loc.newsData} />
            </div>
          </Popup>
        </CircleMarker>
      ))}
    </MapContainer>
  );
};

export default MapComponent;
